import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {SetProductComponent} from "./set-product.component";

const routes: Routes = [
   { path: '', component:SetProductComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SetProductRoutingModule {
  static components = [ SetProductComponent]
}
